import React from 'react';
import SwoopyLogo from './SwoopyLogo';

export default function LoadingScreen({ message = "Finding your Swoopy Picks..." }) {
  return (
    <div 
      className="fixed inset-0 flex items-center justify-center z-50"
      style={{ backgroundColor: 'var(--bg)' }}
    >
      <div className="text-center px-4">
        {/* Logo */}
        <div className="mb-10 flex justify-center">
          <SwoopyLogo variant="icon" size={120} className="animate-pulse" />
        </div>
        
        {/* Message */}
        <p 
          className="text-lg font-medium mb-6"
          style={{ color: 'var(--text)' }}
        >
          {message}
        </p>
        
        {/* Loading Dots */}
        <div className="flex items-center justify-center gap-2">
          <div 
            className="w-2.5 h-2.5 rounded-full animate-bounce"
            style={{ backgroundColor: 'var(--coral)', animationDelay: '0ms' }}
          />
          <div 
            className="w-2.5 h-2.5 rounded-full animate-bounce"
            style={{ backgroundColor: 'var(--coral)', animationDelay: '150ms' }}
          />
          <div 
            className="w-2.5 h-2.5 rounded-full animate-bounce"
            style={{ backgroundColor: 'var(--coral)', animationDelay: '300ms' }}
          />
        </div>
      </div>
    </div>
  );
}
